import { autoinject, observable } from 'aurelia-framework';
import { DialogController } from "aurelia-dialog";
import { WebApiService } from "../../services/web-api-service";
import 'jquery';
import 'notify';
import * as moment from 'moment';
import { CarrierDocument } from '../../models/carrier-document';
import { BusyService } from '../../services/busy-service';
import { CarrierDocumentVersion } from '../../models/carrier-document-version';

@autoinject
export class UpdateDocumentVersionDialog {
    constructor(
        protected controller: DialogController,
        private api: WebApiService,
        private busyService: BusyService) {
        this.api.containerId = "update-document-version-dialog";
    }

    documentVersion: CarrierDocumentVersion;
    isLinked: boolean;
    carrierGuid: string;

    activate(params) {

        this.documentVersion = <CarrierDocumentVersion>JSON.parse(JSON.stringify(params.documentVersion));
        this.carrierGuid = params.carrierGuid;
        this.isLinked = this.documentVersion && this.documentVersion.isLinked;
    }

    save() {

        this.busyService.on();
        let param = this.documentVersion as any;
        param.carrierGuid = this.carrierGuid;
        return this.api.post("document", "updateDocumentVersion", param)
            .then(o => {
                this.controller.ok(this.documentVersion);
            })
            .finally(() => {
                this.busyService.off();
            });
    }

}